var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgJasminePlain(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#8a4182}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "jasmine-plain") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "plain"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M68.49 52.7h-9.44l-2.55-3.28V23.7h14.38v25.72l-2.39 3.28zM55.72 55.1l-2.92 8.98-3.9 1.41-24.47-7.95 4.45-13.67 24.46 7.94 2.38 3.29zM54.04 67.74l7.64 5.55.13 4.14L46.7 98.25 35.06 89.8l15.13-20.82 3.85-1.24zM65.76 73.33l7.65-5.55 3.98 1.16 15.12 20.81-11.63 8.45-15.12-20.81v-4.06zM74.84 64.23l-2.92-8.99 2.33-3.43 24.46-7.94 4.45 13.67-24.47 7.95-3.85-1.26z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M64 1.41A62.59 62.59 0 1 0 126.59 64 62.59 62.59 0 0 0 64 1.41zm-.34 111.5a49.5 49.5 0 1 1 49.5-49.5 49.5 49.5 0 0 1-49.5 49.51z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M61.58 82.99h3.92v19.51h-3.92z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    transform: "rotate(-72 92.722 72.109)",
    d: "M90.77 62.35h3.92v19.51h-3.92z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    transform: "rotate(-144 81.908 38.013)",
    d: "M79.95 28.25h3.92v19.51h-3.92z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    transform: "rotate(144 46.029 38.012)",
    d: "M44.07 28.25h3.92v19.51h-3.92z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    transform: "rotate(72 34.723 72.106)",
    d: "M32.76 62.35h3.92v19.51h-3.92z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJasminePlain);
export default __webpack_public_path__ + "static/media/JasminePlain.cbb688f3617bf02146d784130f002e9c.svg";
export { ForwardRef as ReactComponent };